import NoAccessLayout from "./no_access_layout";

const NoAccessPage = () => {
  return (
      <NoAccessLayout />
  );
};

export default NoAccessPage;